import defaultApi from '@/utils/request';

export default {
  // ========================================================================================================
  // S55W4001 全校空間借用查詢
  // 取得空間使用狀況
  S55W4002_Get_RoomUseList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S55/S55W4002_Get_RoomUseList',
      params,
    });
  },
  // 取得空間使用狀況
  S55W4001_Get_RoomUseSchedule(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S55/S55W4001_Get_RoomUseSchedule',
      params,
    });
  },
  // 取得大樓清單
  S55W4001_Get_buildings(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S55/S55W4001_Get_Buildings',
      params,
    });
  },
  // 取得地點類別清單
  S55W4001_Get_RomKid(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S55/S55W4001_Get_RomKid',
      params,
    });
  },
  // 取得地點清單依據大樓
  S55W4001_Get_RoomList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S55/S55W4001_Get_RoomList',
      params,
    });
  },

  // ========== S55W2003 ============================
  S55W2003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2003_Load',
      params,
    });
  },
  S55W2003_Get_CancelList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2003_Get_CancelList',
      params,
    });
  },
  S55W2003_Get_TeachList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2003_Get_TeachList',
      params,
    });
  },
  S55W2003_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2003_Query',
      params,
    });
  },
  S55W2003_Update_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S55/S55W2003_Update_Cancel',
      data,
    });
  },
  S55W2003_GetPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2003_GetPDF',
      responseType: 'blob',
      params,
    });
  },
  S55W2003_Save(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S55/S55W2003_Save',
      data,
    });
  },
  S55W2003_Get_RoomList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2003_Get_RoomList',
      params,
    });
  },
  S55W2003_Get_timeTableList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2003_Get_timeTableList',
      params,
    });
  },

  // ========== S55W2004 ============================
  S55W2004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2004_Load',
      params,
    });
  },
  S55W2004_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2004_Query',
      params,
    });
  },
  S55W2004_Update_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S55/S55W2004_Update_Cancel',
      data,
    });
  },
  S55W2004_LoadPrintPDFData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2004_LoadPrintPDFData',
      responseType: 'blob',
      params,
    });
  },
  S55W2004_Save(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S55/S55W2004_Save',
      data,
    });
  },
  S55W2004_Update(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S55/S55W2004_Update',
      data,
    });
  },
  S55W2004_Get_RoomList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2004_Get_RoomList',
      params,
    });
  },
  S55W2004_Get_Updatedata(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W2004_Get_Updatedata',
      params,
    });
  },
  // ------------- S55W4003 -----------------------------------------
  S55W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W4003_Load',
      params,
    });
  },

  S55W4003_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S55/S55W4003_Query',
      params,
    });
  },

  // ---------------------------------------------------------------
};
